// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"bug-report"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M9.19543 5.63451C7.00958 6.68156 5.5 8.91449 5.5 11.5V16.5C5.5 20.0899 8.41015 23 12 23C15.5899 23 18.5 20.0899 18.5 16.5V11.5C18.5 8.91449 16.9904 6.68156 14.8046 5.63451C13.9555 5.22779 13.0043 5 12 5C10.9957 5 10.0445 5.22779 9.19543 5.63451Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3 10H5.5M18.5 10H21M3 18H5.5M18.5 18H21M9 5.4L7 3M15 5.4L17 3M5.5 16.5V11.5C5.5 7.91015 8.41015 5 12 5C15.5899 5 18.5 7.91015 18.5 11.5V16.5C18.5 20.0899 15.5899 23 12 23C8.41015 23 5.5 20.0899 5.5 16.5Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M10 11H14M10 17H14","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-bug-report')
export default class BugReportIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'bug-report',
    }
  }
}
